import { t } from 'i18next';
import * as yup from 'yup';

import { nameIdNonRequiredSchema, nameIdSchemaRequired } from '~constants/regexConst';
import { Ticket } from '~hooks/useTickets/models';
import { parseTicketQuantity } from '~utils/tickets/ticket-input';

export const TICKET_NUMBER_MAX_LENGTH = 64;

export const ticketFormSchema = yup.object().shape({
  id: yup.string().notRequired(),
  ticketNumber: yup.string().trim().min(1).max(TICKET_NUMBER_MAX_LENGTH).required(),
  quantity: yup
    .string()
    .required()
    .test(
      'numeric',
      t('form_validation_errors.should_be_number_simple'),
      (value) => parseTicketQuantity(value) !== null,
    ),
  unitOfMeasure: nameIdSchemaRequired,
  imageUrl: yup.string(),
  jobId: yup.string().trim().uuid().required(),
  material: nameIdNonRequiredSchema,
  serviceDate: yup.date(),
  trailerId: yup.string().trim().optional(),
  machineId: yup.string().trim().optional(),
});
export const setDefaultTicketValues = (ticket: Ticket | undefined, jobId: string) => {
  const defaultValues: TicketFormDTO = {
    id: ticket?.id ?? '',
    ticketNumber: (ticket?.ticketNumber || ticket?.ocrTicketNumber) ?? '',
    imageUrl: ticket?.imageUrl ?? '',
    jobId: jobId,
    unitOfMeasure: {
      id: ticket?.unitOfMeasure?.id ?? '',
      name: ticket?.unitOfMeasure?.name ?? '',
    },
    quantity: ticket?.quantity ?? ticket?.ocrNetQuantityTons ?? '',
    material: {
      id: ticket?.material?.id ?? '',
      name: ticket?.material?.name ?? '',
    },
    serviceDate:
      ticket?.serviceDate || ticket?.ocrServiceDate || ticket?.createdAt
        ? new Date(ticket?.serviceDate || ticket?.ocrServiceDate || ticket?.createdAt)
        : undefined,
    trailerId: ticket?.externalTrailerId ?? '',
    machineId: ticket?.externalMachineId ?? '',
  };

  return defaultValues;
};
export type TicketFormDTO = yup.InferType<typeof ticketFormSchema>;
